// Simple spice utilities
export const SPICE_LEVELS = [
  { id: 1, name: 'mild', label: 'Mild', pepperCount: 1 },
  { id: 2, name: 'medium', label: 'Medium', pepperCount: 2 },
  { id: 3, name: 'hot', label: 'Hot', pepperCount: 3 }
];

export const DEFAULT_SPICE_LEVEL = 2;

export const shouldShowSpiceLevel = (item: any): boolean => {
  // Check if the property exists and handle both "yes"/"Yes" and "no"/"No"
  if (!item || !item.is_spice_applicable) {
    return false;
  }
  
  const spiceApplicable = item.is_spice_applicable.toString().toLowerCase();
  return spiceApplicable === "yes";
};

// Additional reusable spice utilities
export const isSpiceLevelRequired = (item: any): boolean => {
  // Check if the property exists and handle both "yes"/"Yes" and "no"/"No"
  if (!item || !item.is_spice_applicable) {
    return false;
  }
  
  const spiceApplicable = item.is_spice_applicable.toString().toLowerCase();
  return spiceApplicable === 'yes';
};

export const isValidSpiceLevel = (spiceLevel: number): boolean => {
  return spiceLevel > 0 && spiceLevel <= SPICE_LEVELS.length;
};

export const getSpiceLevelById = (id: number) => {
  return SPICE_LEVELS.find(level => level.id === id);
};
